<template>
  <div class="bg-home-banner-bg-2-mobile bg-cover md:bg-home-banner-bg-2-desktop">
    <div class="flex flex-col justify-self-center w-[90%] max-w-[1200px] md:mx-auto md:flex-row items-center mx-5 py-20 gap-10">
      <div class="w-full md:w-1/2 my-3 md:my-0 text-center md:text-start">
        <h2 class="text-ROJO_LEON mx-auto md:ml-0 flex flex-col font-bold text-lg md:text-2xl">
          <span class="flex flex-row items-center justify-center md:justify-start">CON
            <img class="h-4 md:h-5 px-1 mb-1.5" :src="'/img/shared/leon-logo-text.webp'" alt="leon-logo-text" />
          </span>
          <span>OBTIENES MÁS QUE BATERÍAS</span>
        </h2>

        <p class="font-bold my-3 text-lg">Las mejores marcas del mundo</p>
        <p class="md:max-w-[500px] text-left">
          Somos distribuidores oficiales de las mejores marcas de neumáticos y
          contamos con stock permanente.
        </p>
        <button @click="handleClick"
          class="hidden md:block bg-ROJO_LEON text-white rounded-md font-bold py-2 my-10 hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON w-1/2 transition mx-auto md:mx-0 text-center">
          Comprar BATERÍAS
        </button>
      </div>

      <!-- Elementos DESKTOP -->
      <div class="hidden md:grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto my-6">
        <div v-for="(brand, index) in brands.slice(0, 2)" :key="index"
          class="w-[300px] h-[170px] bg-white rounded-md flex items-center justify-center hover:scale-105 transition-transform p-6 group shadow-lg">
          <img class="group-hover:filter-none filter transition-filter duration-300" :src="brand.src"
            :alt="brand.alt" />
        </div>
        <div
          class="col-span-1 md:col-span-2 w-[300px] h-[170px] bg-white rounded-md flex items-center justify-center hover:scale-105 transition-transform p-6 group shadow-lg mx-auto">
          <img class="group-hover:filter-none filter transition-filter duration-300" :src="brands[2].src"
            :alt="brands[2].alt" />
        </div>
      </div>

      <!-- ELEMENTOS MOBILE CARRUSEL -->
      <div v-if="swiperInit" class="carrusel_container w-full md:hidden">
        <div class="carrusel_aqui w-full relative">
          <swiper class="mySwiper h-auto p-2 w-full" :modules="[SwiperNavigation, SwiperPagination, SwiperAutoplay]"
            :slides-per-view="1.3" :space-between="15" :navigation="false" :pagination="false"
            :autoplay="{ delay: 3000 }" :centered-slides="true" :breakpoints="{
              320: {
                slidesPerView: 1.3,
                spaceBetween: 15,
                centeredSlides: true,
              },
              480: {
                slidesPerView: 1.3,
                spaceBetween: 15,
                centeredSlides: true,
              },
              640: {
                slidesPerView: 1.3,
                spaceBetween: 15,
                centeredSlides: true,
              }
            }">
            <swiper-slide v-for="(brand, index) in brands" :key="index" class="flex justify-center">
              <div
                class="w-[280px] sm:w-[300px] h-[170px] bg-white rounded-md flex items-center justify-center hover:scale-105 transition-transform p-6 group shadow-lg">
                <img
                  class="group-hover:filter-none filter transition-filter duration-300 max-w-full max-h-full object-contain"
                  :src="brand.src" :alt="brand.alt" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <button @click="handleClick"
        class="mx-auto text-center text-white bg-ROJO_LEON w-50 rounded-md py-2 text-s font-semibold my-3.5 md:hidden hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON">
        Comprar BATERÍAS
      </button>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();
const router = useRouter();
const swiperInit = ref(false);

const scrollToTop = () => {
  if (!import.meta.client) return;
  window.scrollTo({ top: 140, behavior: "smooth" });
  const input = document.querySelector("#first-input");
  if (input) input.focus();
};

const handleClick = () => {
  if (route.path === '/baterias') {
    scrollToTop();
  } else {
    router.push('/baterias');
  }
};

const brands = [
  {
    src: '/img/home/svg_logos_marcas/ACDELCOV2.svg',
    alt: 'logo-acdelco'
  },
  {
    src: '/img/home/svg_logos_marcas/FULLSTARKV2.svg',
    alt: 'logo_fullstark'
  },
  {
    src: '/img/home/svg_logos_marcas/DELKORV2.svg',
    alt: 'logo_delkor'
  }
];

onMounted(() => {
  swiperInit.value = true;
});
</script>